import config from '../config';
import { authHeader, handleResponse, commonRequestOptions, customFetch } from '../helpers';

const endpointPath = config.api.API_URL + '/relationship';

export const relationshipService = {
  getByObjectId,
  getByDatasets,
  getRelatedDatasets,
};

function getByObjectId(objectName, objectId, signal) {
  const requestOptions = { method: 'GET', headers: authHeader(), ...commonRequestOptions() };
  return customFetch(
    `${endpointPath}/get_by_object_id/${objectName}/${objectId}`,
    requestOptions,
    signal
  ).then(handleResponse);
}
/**
 * Sends a GET request for the relationships of several datasets at once.
 *
 * Each dataset's subtree is included, as it is for a single one: an API endpoint holds its fields,
 * and so its relationships, on its child datasets.
 *
 * @param {Array<number|string>} datasetIds
 * @param {AbortSignal} [signal]
 * @returns {Promise<{ relationships: object[] }>} Every relationship touching any of them, once.
 */
function getByDatasets(datasetIds, signal) {
  const requestOptions = { method: 'GET', headers: authHeader(), ...commonRequestOptions() };
  return customFetch(
    `${endpointPath}/datasets/${(datasetIds || []).join(',')}`,
    requestOptions,
    signal
  ).then(handleResponse);
}

function getRelatedDatasets(datasetId, signal) {
  const requestOptions = { method: 'GET', headers: authHeader(), ...commonRequestOptions() };
  return customFetch(
    `${endpointPath}/get_related_datasets/${datasetId}`,
    requestOptions,
    signal
  ).then(handleResponse);
}
